import React, { useEffect, useState } from "react";
import { formatDate, readFile, toAbsoluteUrl } from "../../_helpers";

export function LastBuild() {

    const [lastBuild, setLastBuild] = useState('unknown');
    useEffect(() => {
        readFile(toAbsoluteUrl(`/deployed`)).then((_deployed) => {
            setLastBuild(_deployed !== '' ? formatDate(Number(_deployed) * 1000) : 'unknown');
        });
    }, []);

    return (
        <>
            {(lastBuild !== '') && <p style={{ fontSize: '10px' }}>Last build {lastBuild}</p>}
        </>
    );
}
